import React, { useState } from "react";
import './Login.css';
import axios from "axios";
import { API_URL } from "../Constants/constants";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate()
  const [isError, setIsError] = useState(false)

  const [loginData, setLoginData] = useState({
    username: "",
    password: ""
  });

  const [registerData, setRegisterData] = useState({
    fullname: "",
    username: "",
    password: ""
  });

  const onSwitch = () => {
    setIsLogin(!isLogin);
  };

  const handleLoginChange = (e) => {
    setIsError(false)
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegisterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRegister = () => {
    axios.post(`${API_URL}/auth/register`,{
        full_name: registerData.fullname,
        username: registerData.username,
        password: registerData.password
    }).then((res) => {
        localStorage.setItem('token', "afnjfkjnbnbgkhkgbhdvfnlksnlkfnlacw6ysjkw6e5jw4eka")
        navigate('/')
    }).catch((err) => {
    
    })
  }

  const handleLogin = (e) => {
    e.preventDefault()
    axios.post(`${API_URL}/auth/login`,{
        username: loginData.username,
        password: loginData.password
    }).then((res) => {
        localStorage.setItem('token', res.data.access_token)
        localStorage.setItem('refresh_token', res.data.refresh_token)
        navigate('/')
        window.location.reload()
    }).catch((err) => {
      setIsError(true)
    })
  }

  return (
    <div className="login-body">
      <div className="login-container">
        {isLogin ? (
          <form autoComplete="off" onSubmit={handleLogin} className="card">
            <h2 className="title">Login</h2>
            <input
              type="text"
              name="username"
              placeholder="Username"
              className="input"
              value={loginData.username}
              onChange={handleLoginChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              className="input"
              value={loginData.password}
              onChange={handleLoginChange}
            />
            {isError && <span style={{color: "red"}}> Incorrect username or password.</span>}
            <button onClick={handleLogin} className="btn btn-primary logBtn">
              Login
            </button>
            <p className="switch-text">
              Don't have an account?{" "}
              <span 
                onClick={onSwitch}
                className="link">
                Register
              </span>
            </p>
          </form>
        ) : (
          <div className="card">
            <h2 className="title">Register</h2>
            <input
              type="text"
              name="fullname"
              placeholder="Full Name"
              className="input"
              value={registerData.fullname}
              onChange={handleRegisterChange}
            />
            <input
              type="text"
              name="username"
              placeholder="Username"
              className="input"
              value={registerData.username}
              onChange={handleRegisterChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              className="input"
              value={registerData.password}
              onChange={handleRegisterChange}
            />
            <button className="btn btn-primary logBtn" onClick={handleRegister}>
              Register
            </button>
            <p className="switch-text">
              Already have an account?{" "}
              <span onClick={onSwitch} className="link">
                Login
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
